import extendAlmaGlobal from "../../utils/almaglobal";
import { createLogger } from "../../utils/logger";
const logger = createLogger("AlmadQueue");
function executeCommand(command) {
    if (typeof command === "function") {
        logger.logInfo("Executing command from queue");
        command.call(window, {});
    }
}
function executeQueue(queue) {
    logger.logInfo("Executing queue...");
    queue.forEach((cmd) => executeCommand(cmd));
}
function installCommandQueue() {
    logger.logInfo("Checking for almad-queue from ALMA global");
    if (!window?.ALMA?.ad?.queue) {
        logger.logInfo("Installing queue to ALMA global");
        extendAlmaGlobal({ queue: [] }, "ad");
    }
    if (window?.ALMA?.ad?.queue && Array.isArray(window?.ALMA?.ad?.queue)) {
        logger.logInfo("Installing immediate queue handler");
        Object.defineProperty(window.ALMA.ad.queue, "push", {
            enumerable: false,
            configurable: false,
            writable: false,
            value(cmd, ...rest) {
                Array.prototype.push.apply(this, rest);
                if (typeof cmd === "function") {
                    executeCommand(cmd);
                }
            },
        });
        return window?.ALMA?.ad?.queue;
    }
    throw new Error("Unable to install command queue to ALMA global");
}
export { installCommandQueue, executeQueue };
//# sourceMappingURL=commandqueue.js.map